/**
 * get the selected transition value and add the string of it to the header as a class.
 *
 * returns nothing
 */
export default function cm4allNavigationTransition() {
  const NAVIGATION_TRANSITION = window
    .getComputedStyle(document.body)
    .getPropertyValue('--cm4all-theme-navigation-transition')
    .trim();
  const THEME_HEADER = document.querySelector('.cm4all-theme-header');
  if (THEME_HEADER) {
    const OLD_TRANSITION = THEME_HEADER.className.match(
      /cm4all-navigation-transition[^\s]+/
    );
    if (OLD_TRANSITION && OLD_TRANSITION.length === 1) {
      THEME_HEADER.classList.remove(OLD_TRANSITION);
    }
    THEME_HEADER.classList.add(
      `cm4all-navigation-transition--${NAVIGATION_TRANSITION}`
    );

    if (NAVIGATION_TRANSITION === 'box') {
      const NAVIGATIONS = document.querySelectorAll(
        '.cm4all-theme-navigation-main__menu > ul'
      );
      for (const NAVIGATION of NAVIGATIONS) {
        const NAVIGATION_POINTS = NAVIGATION.childNodes;
        const NAVIGATION_BACKGROUND_SLIDER = document.createElement('div');
        NAVIGATION_BACKGROUND_SLIDER.classList.add(
          'cm4all-theme-navigation__background-slider'
        );

        NAVIGATION.appendChild(NAVIGATION_BACKGROUND_SLIDER);

        for (const NAVIGATION_POINT of NAVIGATION_POINTS) {
          NAVIGATION_POINT.addEventListener('mouseenter', () => {
            NAVIGATION_BACKGROUND_SLIDER.style.width = `${NAVIGATION_POINT.offsetWidth}px`;
            NAVIGATION_BACKGROUND_SLIDER.style.height = `${NAVIGATION_POINT.offsetHeight}px`;
            NAVIGATION_BACKGROUND_SLIDER.style.transform = `translateY(${
              NAVIGATION_POINT.getBoundingClientRect().top -
              NAVIGATION.getBoundingClientRect().top
            }px)`;
            NAVIGATION_BACKGROUND_SLIDER.style.transform += `translateX(${
              NAVIGATION_POINT.getBoundingClientRect().left -
              NAVIGATION.getBoundingClientRect().left
            }px)`;
          });
        }
      }
    }
    /*
    const SUBNAVIGATION_POINTS = document.querySelectorAll(
      '.cm4all-theme-navigation-main__menu > ul > li > ul > li'
    );*/
    const HAS_SUBNAVIGATION = document.querySelectorAll(
      '.cm4all-theme-navigation-main__menu > ul > li.menu-item-has-children'
    );

    /**
     *  Set and increase transition delay for every subnavigation point
     *
     * @param {boolean} enterNavigation   activator to add or remove transition delay prop from all elm
     * @param {number}  transitionCounter start value for transition delay
     * @param {number}  delayIncrease     value that is added after each loop to transitionCounter
     *  @return nothing
     */

    const setTransitionDelay = (
      enterNavigation,
      transitionCounter,
      delayIncrease,
      id
    ) => {
      if (id !== '') {
        for (const SUBNAVIGATION_POINT of document.querySelectorAll(
          `#${id} li`
        )) {
          if (enterNavigation) {
            SUBNAVIGATION_POINT.style.transitionDelay = `${transitionCounter}s`;
            transitionCounter += delayIncrease;
          } else {
            SUBNAVIGATION_POINT.style.transitionDelay = '0s';
          }
        }
      }
    };

    for (let i = 0; i < HAS_SUBNAVIGATION.length; i++) {
      HAS_SUBNAVIGATION[i].addEventListener(
        'mouseenter',
        setTransitionDelay.bind(null, true, 0.05, 0.05, HAS_SUBNAVIGATION[i].id)
      );
      HAS_SUBNAVIGATION[i].addEventListener(
        'mouseleave',
        setTransitionDelay.bind(
          null,
          false,
          0.05,
          0.05,
          HAS_SUBNAVIGATION[i].id
        )
      );
    }
  }
}

document.documentElement.addEventListener('cm4all-theme-settings', () => {
  cm4allNavigationTransition();
});
